import { useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';

import { DRAFT_RISKS, QB_PRODUCTS, useDeleteDraftRisk, useGetDraftRiskList, useGetProducts } from 'lib/quoteBind';
import { showModal } from 'stores';
import * as utils from 'utils';

// app
import { QuoteBindDraftRiskView } from './QuoteBindDraftRisk.view';

export const QuoteBindDraftRisk = ({ displayStyle }) => {
  const dispatch = useDispatch();
  const [params, setParams] = useState({
    page: 1,
    size: 12,
  });
  const brand = useSelector((state) => state.ui.brand);

  const { data: programmesProductsData } = useGetProducts(QB_PRODUCTS);
  const { data: draftListData, isLoading: draftRiskListLoading } = useGetDraftRiskList(DRAFT_RISKS, params);
  const { mutate: deleteDraftRisk } = useDeleteDraftRisk();

  const draftList = draftListData?.content || [];
  const riskProducts = useMemo(() => programmesProductsData?.data || [], [programmesProductsData]);

  const draftPaginationObj = {
    page: params.page - 1,
    rowsTotal: draftListData?.pagination?.totalElements || 0,
    rowsPerPage: params?.size,
  };

  // draft pagination
  const handleDraftChangePage = (event, newPage) => {
    setParams({ ...params, page: newPage + 1 });
  };

  const handleDraftChangeRowsPerPage = (event) => {
    setParams({ ...params, size: event.target.value });
  };

  const popoverActions = [
    {
      id: 'edit-draft-risk',
      label: 'app.edit',
      callback: (popoverData) => handleEditDraftRisk(popoverData),
    },
    {
      id: 'delete-draft-risk',
      label: 'app.delete',
      callback: (popoverData) => handleDeleteDraftRisk(popoverData),
    },
  ];

  const handleDeleteDraftRisk = (popoverData) => {
    dispatch(
      showModal({
        component: 'CONFIRM_DELETE',
        props: {
          title: 'products.tabs.draftRisks.deleteDraftRisk',
          fullWidth: true,
          maxWidth: 'xs',
          disableAutoFocus: true,
          componentProps: {
            submitHandler: () => {
              deleteDraftRisk({ draftId: get(popoverData, 'id'), isSubmitted: false });
            },
          },
        },
      })
    );
  };

  const handleEditDraftRisk = (popoverData) => {
    const draftId = popoverData.id;
    const riskData = popoverData.risk;
    let product = {};
    riskProducts.forEach((rp) => {
      if (rp.value.toLowerCase() === riskData.riskType.toLowerCase()) {
        product = rp;
      }
    });
    dispatch(
      showModal({
        component: 'ADD_EDIT_QUOTE_BIND',
        props: {
          title: product.label,
          fullWidth: true,
          disableBackdropClick: true,
          enableFullScreen: true,
          maxWidth: 'xl',
          componentProps: {
            product,
            riskData,
            draftId,
          },
        },
      })
    );
  };

  return (
    <>
      <Helmet>
        <title>{`${utils.string.t('products.title')} - ${utils.app.getAppName(brand)} - ${utils.string.t(
          'products.tabs.draftRisks.label'
        )}`}</title>
      </Helmet>
      <QuoteBindDraftRiskView
        displayStyle={displayStyle}
        pagination={draftPaginationObj}
        listDraftRisk={draftList}
        draftRiskListLoading={draftRiskListLoading}
        popoverActions={popoverActions}
        riskProducts={riskProducts}
        handlers={{
          handleEditDraftRisk,
          handleDeleteDraftRisk,
          changePage: handleDraftChangePage,
          changeRowsPerPage: handleDraftChangeRowsPerPage,
        }}
      />
    </>
  );
};
